import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { InvoicingMethod } from '@epi-forms/helpers';
import { InvoicingMethodFieldProps } from '@epi-models/forms/Controls';

export function PaperInvoiceField({
  readOnly,
  isActive
}: InvoicingMethodFieldProps) {
  const { altGray2, primaryBackColorLight10 } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      border={`1px solid ${altGray2}`}
      px={3}
      py={2}
      mt={3}
      bgcolor={isActive ? primaryBackColorLight10 : undefined}
    >
      <FormControlLabel
        value={InvoicingMethod.Paper}
        control={<Radio />}
        label={t('controls.paper_radio_label')}
        readOnly={readOnly}
        id="invoicing-method_paper"
      />
    </Box>
  );
}
